import { ENUM_MESSAGE_TYPE } from '../../enum.yk-message-core'

import MessageText from './message-text/index.vue'
import MessageImage from './message-image/index.vue'
import MessageVoice from './message-voice/index.vue'
import MessageVideo from './message-video/index.vue'
import MessageGif from './message-gif/index.vue'
import MessageFile from './message-file/index.vue'
import MessageLink from './message-link/index.vue'
import MessagePersonalCard from './message-personal-card/index.vue'
import MessageLocation from './message-location/index.vue'
import MessageSystemMessage from './message-system-message/index.vue'
import MessageMiniProgram from './message-mini-program/index.vue'
import MessageQuote from './message-quote/index.vue'
import MessagePoke from './message-poke/index.vue'
import MessageAudioVisual from './message-audio-visual/index.vue'

const MESSAGE_TYPE_COMPONENT_MAP = {
  [ENUM_MESSAGE_TYPE.TEXT.type]: MessageText,
  [ENUM_MESSAGE_TYPE.IMAGE.type]: MessageImage,
  [ENUM_MESSAGE_TYPE.VOICE.type]: MessageVoice,
  [ENUM_MESSAGE_TYPE.VIDEO.type]: MessageVideo,
  [ENUM_MESSAGE_TYPE.GIF.type]: MessageGif,
  [ENUM_MESSAGE_TYPE.FILE.type]: MessageFile,
  [ENUM_MESSAGE_TYPE.LINK.type]: MessageLink,
  [ENUM_MESSAGE_TYPE.PERSONAL_CARD.type]: MessagePersonalCard,
  [ENUM_MESSAGE_TYPE.LOCATION.type]: MessageLocation,
  [ENUM_MESSAGE_TYPE.SYSTEM_MESSAGE.type]: MessageSystemMessage,
  [ENUM_MESSAGE_TYPE.MINI_PROGRAM.type]: MessageMiniProgram,
  [ENUM_MESSAGE_TYPE.QUOTE.type]: MessageQuote,
  [ENUM_MESSAGE_TYPE.POKE.type]: MessagePoke,
  [ENUM_MESSAGE_TYPE.AUDIO_VISUAL.type]: MessageAudioVisual
}

export { MESSAGE_TYPE_COMPONENT_MAP }
